import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-gate",
  "use": "icon-gate-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\" id=\"icon-gate\">\r\n<path d=\"M114.8,27.3c7.3,0,13.2,6,13.2,13.3s-5.9,13.3-13.2,13.3H55.3v59.8c0,4.4-2.2,6.7-6.6,6.7H9c-4.4,0-6.6-2.2-6.6-6.7V20.7\r\n\tC2.4,16.2,4.6,14,9,14h39.7c4.4,0,6.6,2.2,6.6,6.7v6.6H114.8L114.8,27.3z M42,60.5H15.6v6.6H42V60.5z M28.8,27.3\r\n\tc-7.3,0-13.2,6-13.2,13.3l0,0c0,7.3,5.9,13.3,13.2,13.3S42,47.9,42,40.6S36.1,27.3,28.8,27.3L28.8,27.3z M71.8,33.9l-16.5,0\r\n\tc-3.7,0-6.6,3-6.6,6.6c0,3.7,3,6.6,6.6,6.6c0,0,0,0,0,0h9.9L71.8,33.9L71.8,33.9z M98.2,33.9H78.4l-6.6,13.3h19.8L98.2,33.9\r\n\tL98.2,33.9z M114.8,33.9h-9.9l-6.6,13.3h16.5c3.7,0,6.6-3,6.6-6.6C121.4,36.9,118.4,33.9,114.8,33.9z M32.1,34.8\r\n\tc3.2,1.8,4.4,5.8,2.6,9c-1.8,3.2-5.8,4.4-9,2.6c-0.1,0-0.2-0.1-0.3-0.2c-3.1-1.9-4.1-6-2.1-9.2C25.2,34.2,29,33.2,32.1,34.8\r\n\tL32.1,34.8z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/gate.svg
// module id = 6WwC
// module chunks = 213